<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <PageTitle title="Novo serviço de Motoboy" :customer="userType === '1' || userType === '2' || userType === '3'" @change="selected" />
    </div>
    <MotoboySender ref="sender" :customer="customerId" :userName="userName" :state="state" @confirm="confirm" @changed="state = 'CHANGED'"/>
    <el-row :gutters="5" v-if="state === 'VIEW'">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <MotoboyDeliver ref="deliver" :customer="customerId" :userType="userType" />
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <MotoboyObject ref="object" @add="add" />
      </el-col>
    </el-row>
    <el-row :gutter="2" style="text-align: center" v-if="deliveryList.length > 0">
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix">
            <span>Itenerário</span>
          </div>
          <el-timeline>
            <el-timeline-item
              :hide-timestamp="true"
              v-for="(deliveryData, index) in deliveryList"
              :key="index">
              <b>{{deliveryData.name}} - {{deliveryData.cep}}</b><br />
              {{ deliveryData.address }}, {{ deliveryData.number }} {{ deliveryData.extent }}<br />
              {{ deliveryData.neighborhood }}, {{ deliveryData.city }} {{ deliveryData.state }}<br />
              <el-button type="danger" size="small" icon="el-icon-delete" @click="remove(index)"></el-button>
            </el-timeline-item>
          </el-timeline>          
          <div class="bottom clearfix right" style="margin-bottom: 10px">
            <el-button type="primary" @click="calculate">Calcular preço</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card v-if="tableData.length > 0">
          <el-row :gutter="2">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" v-for="record of tableData" :key="record.id"
              v-show="record.pricetable > 0 || !record.available">
              <el-card :ref="record.id" shadow="always" style="min-height: 120px" :body-style="{
                'background-color': record.id == selectedService ? '#f4f4f5' : '',
              }">
                <img v-if="record.icon" :src="record.icon" width="100%" height="80px" class="image" />
                <el-row :gutter="5" justify="center" v-else>
                  <el-col :xs="24" style="text-align: center">
                    <span>{{ record.name }}</span><br />
                  </el-col>
                </el-row>
                <el-row :gutter="5" justify="center">
                  <el-col :xs="24" v-if="record.available" style="text-align: center">
                    <el-link @click="choice(record)" type="success">{{
                      record.pricetable
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}</el-link>
                  </el-col>
                  <el-col :xs="24" v-else-if="!record.available" style="text-align: center">
                    <el-alert :description="record.message" type="warning" :closable="false">
                    </el-alert>
                  </el-col>
                </el-row>
                <el-row :gutter="5" v-if="record.available">
                  <el-col :xs="24" style="text-align: center">
                    <el-tag v-if="record.deadline" type="info" style="margin-top: 3px" size="small">
                      Mesmo dia</el-tag>
                  </el-col>
                </el-row>
                <el-row :gutter="5" v-if="record.available">
                  <el-col :xs="24">
                    <el-button type="primary" @click="choice(record)" size="mini" v-show="record.id !== selectedService"
                      style="margin-top: 3px; width: 100%">Selecionar</el-button>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <div class="bottom clearfix right" style="margin-bottom: 10px" v-if="selectedService">
            <el-button @click="submit('save')">Salvar para depois</el-button>
            <el-button type="success" @click="submit('request')">Solicitar motoboy agora</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { MotoboyService } from "@/services/customers/motoboy.services";
import PageTitle from "../../../../maisenvios/layout/PageTitle.vue";
import MotoboySender from "./components/MotoboySender.vue";
import CustomerList from "../../register/customer/CustomerList.vue";
import MotoboyDeliver from "./components/MotoboyDeliver.vue";
import MotoboyObject from "./components/MotoboyObject.vue";

export default {
  name: "MotoboyAddPage",
  components: {
    PageTitle,
    MotoboySender,
    MotoboyDeliver,
    MotoboyObject,
    CustomerList,
  },
  data() {
    return {
      userType: '2',
      userName: '',

      selectedService: "",
      state: "CHANGED",
      customerId: "",
      tableData: [],
      deliveryList: [],
      total: 0,
      records: 50,
      page: 1,
    };
  },
  methods: {
    remove(index) {
      console.log('index', index)
      this.deliveryList.splice(index, 1);
    },
    confirm() {
      this.state = 'VIEW';
    },
    choice(serviceData) {
      this.selectedService = serviceData.id;
    },
    selected(customerData) {
      this.customerId = customerData.id;
    },
    submit(action) {
      const vm = this;
      vm.loading = true;
      MotoboyService.add({
        sender: this.$refs.sender.ruleForm,
        delivery: vm.deliveryList,
        service: vm.selectedService,
        customer: this.customerId,
        action,
      }) 
        .then((response) => {
          if (action === 'request') {
            this.$message({
              type: "success",
              message: "Motoboy solicitado com sucesso!",
            });
          } else {
            this.$message({
              type: "success",
              message: "Destinatário adicionado com sucesso!",
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    calculate() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      MotoboyService.calculate({
        sender: this.$refs.sender.ruleForm,
        delivery: this.deliveryList,
        object: this.$refs.object.ruleForm,
      }) 
        .then((response) => {
          vm.selectedService = '';
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      const vm = this;
      const deliveryForm = Object.assign({}, this.$refs.deliver.ruleForm);
      if (!deliveryForm.cep) {
        return this.$message({
          type: "error",
          message: "CEP deve ser informado",
        });
      }
      const deliveryData = vm.deliveryList.find(x => x.cep === deliveryForm.cep && x.number === deliveryForm.number);
      if (deliveryData) {
        return this.$message({
          type: "error",
          message: "CEP já relacionado ao itinerário",
        });
      }

      const objectForm = Object.assign({}, this.$refs.object.ruleForm);
      if (+objectForm.weight <= 0 || !objectForm.contents) {
        return this.$message({
          type: "error",
          message: "Favor informar o peso e/ou conteudo da encomenda",
        });
      }
      const content = Object.assign(deliveryForm, objectForm)
      vm.deliveryList.push(content);
      this.$refs.deliver.clear();
      this.$refs.object.clear();
      vm.tableData = [];
      vm.selectedService = '';

      /*vm.loading = true;
      MotoboyService.calculate({
        sender: this.$refs.sender.ruleForm,
        delivery: [this.$refs.deliver.ruleForm],
        object: this.$refs.object.ruleForm,
      }) 
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
      */
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        console.log(response)
        vm.userType = response.type;
        vm.userName = response.name;
        vm.customerId = response.customers ? response.customers.id : null;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
</style>  